import {Badge} from "@mui/material";
import React from "react";
import {useQuery} from "@apollo/client";
import {GET_USER_DOCUMENTS} from "../../../../store/queries/GetUserDocuments";
import {GetUserDocumentsQuery, VerificationStatus} from "../../../../gql/graphql";

export const UserBadge : React.FC<{navigation?:boolean, children?: React.ReactNode}> = (props) => {
    const documents = useQuery<GetUserDocumentsQuery>(GET_USER_DOCUMENTS, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    });
    
    if(documents.data?.documents)
    {
        let numberOfVerifications = 0;
        if(documents.data?.documents.identityDocument.verificationStatus == VerificationStatus.NeedsVerification)
            numberOfVerifications +=1;

        if(documents.data?.documents.addressDocument.verificationStatus == VerificationStatus.NeedsVerification)
            numberOfVerifications +=1;

        if(documents.data?.documents.solvencyDocument.verificationStatus == VerificationStatus.NeedsVerification)
            numberOfVerifications +=1;


       documents.data?.documents.bankAccountDocuments.forEach((doc)=> {if(doc.verificationStatus == VerificationStatus.NeedsVerification)
            numberOfVerifications +=1;});


        documents.data?.documents.paymentMethodsDocuments.forEach((doc)=> {if(doc.verificationStatus == VerificationStatus.NeedsVerification)
            numberOfVerifications +=1;});

        documents.data?.documents.walletDocuments.forEach((doc)=> {if(doc.verificationStatus == VerificationStatus.NeedsVerification)
            numberOfVerifications +=1;});

        return (<Badge color={'error'} badgeContent={numberOfVerifications} sx={{'& .MuiBadge-badge': props.navigation?? false ? { right:-16,top: 13} : { right:8,top: 8}}}>
            {props.children}
        </Badge>);
    }
 
    return (<>{props.children}</>)
}
